import { render, staticRenderFns } from "./ColumnEdit.vue?vue&type=template&id=ae9cef2c"
import script from "./ColumnEdit.vue?vue&type=script&lang=ts"
export * from "./ColumnEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae9cef2c')) {
      api.createRecord('ae9cef2c', component.options)
    } else {
      api.reload('ae9cef2c', component.options)
    }
    module.hot.accept("./ColumnEdit.vue?vue&type=template&id=ae9cef2c", function () {
      api.rerender('ae9cef2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/ColumnEdit.vue"
export default component.exports